import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { dismissAPIError, trackInHeap } from '../../actions';
import { ERROR_RETRY } from '../../constants/heapEvents';
import { urlFromErrorSelector, actionFromErrorSelector } from '../../reducers/selectors';
import Button from '../Button';
import Modal from '../Modal';

export const ErrorModal = ({
  apiErrors,
  dispatchTrackInHeap,
  dispatchDismissAPIError,
  dispatchAction,
}) => {
  const [showModal, setModal] = useState(false);
  const heapEventType = ERROR_RETRY;

  const retryError = () => {
    const errorList = [];
    apiErrors.forEach(apiError => {
      const { id, error } = apiError;
      const { action } = error;
      const errorDetails = getErrorDetails(apiError);

      errorList.push(errorDetails);
      dispatchAction(action);
      dispatchDismissAPIError(id);
    });

    const heapEventPayload = {
      heapEventType,
      'Application Error Count': apiErrors.length,
      errorDetailsIn: errorList,
    };
    dispatchTrackInHeap(heapEventPayload);
    setModal(false);
  };

  const getErrorDetails = apiError => {
    const details = {
      url: urlFromErrorSelector(apiError),
      actionType: actionFromErrorSelector(apiError),
    };

    return details;
  };

  useEffect(() => {
    if (apiErrors.length > 0) {
      setModal(true);
    }
  }, [apiErrors]);

  return (
    <Modal isOpen={showModal} title="An error occurred" onClose={retryError}>
      <div className="row-spacer">
        An error occurred. Please wait a couple of minutes and try again.
      </div>

      <div className="row-spacer">
        <Button type="button" onClick={retryError}>
          Retry
        </Button>
      </div>
    </Modal>
  );
};

ErrorModal.propTypes = {
  apiErrors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  dispatchTrackInHeap: PropTypes.func.isRequired,
  dispatchDismissAPIError: PropTypes.func.isRequired,
  dispatchAction: PropTypes.func.isRequired,
};

export const mapStateToProps = state => ({
  apiErrors: state.apiErrors,
});

export const mapDispatchToProps = dispatch => ({
  dispatchTrackInHeap: heapEventType => dispatch(trackInHeap(heapEventType)),
  dispatchDismissAPIError: errorId => dispatch(dismissAPIError(errorId)),
  dispatchAction: action => dispatch(action),
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
